import {useContext} from 'react';

import {LibraryContext} from '@/screens/Library/context';

export const useLibraryContext = () => useContext(LibraryContext);
